import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'popup-icones',
    templateUrl: './popup-icones.component.html',
    styleUrls: ['./popup-icones.component.css']
})
export class PopupIconesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
